import { Component, Input, OnInit } from '@angular/core';
import { asyncScheduler, BehaviorSubject, forkJoin } from 'rxjs';
import { observeOn } from 'rxjs/operators';
import { TipoCalculoRastreamentoEnum } from '~model/vo/parametros-vo';
import { emptyResumo, ResumoVo } from '~model/vo/resumo-vo';

@Component({
  selector: 'app-rota-detalhes-resumo',
  templateUrl: './rota-detalhes-resumo.component.html',
  styleUrls: ['./rota-detalhes-resumo.component.scss'],
})
export class RotaDetalhesResumoComponent implements OnInit {
  @Input() resumo$: BehaviorSubject<ResumoVo> = new BehaviorSubject<ResumoVo>(emptyResumo());
  @Input() loaded$!: BehaviorSubject<boolean>;
  loaded: boolean = false;

  duracaoExecutado!: string;
  duracaoPlanejado!: string;

  distanciaExecutado!: string;
  distanciaPlanejado!: string;

  visitasExecutado!: string;
  visitasPlanejado!: string;
  themeLoader = { 'margin-bottom.px': 3 };
  themeDown = { 'height.rem': 1.6 };
  mensagemRastreamento: string = "APPDISTANCE"; 
  ngOnInit(): void {
    this.loaded$.pipe(observeOn(asyncScheduler, 500)).subscribe({
      next: loaded => {
        this.resumo$.subscribe({
          next: resumo => {
            this.mensagemRastreamento =
              resumo.executado.calculoKmExecutado === TipoCalculoRastreamentoEnum.TERCEIROS
                ? "THIRDPARTYDISTANCE"
                : "APPDISTANCE";            

            const plan = resumo.planejado;
            const exec = resumo.executado;

            this.duracaoExecutado = this.percentual(exec.tempoNumero, plan.tempoNumero, 'E');
            this.duracaoPlanejado = this.percentual(exec.tempoNumero, plan.tempoNumero, 'P');
            this.distanciaExecutado = this.percentual(exec.distancia, plan.distancia, 'E');
            this.distanciaPlanejado = this.percentual(exec.distancia, plan.distancia, 'P');
            this.visitasExecutado = this.percentual(exec.visitas, plan.visitas, 'E');
            this.visitasPlanejado = this.percentual(exec.visitas, plan.visitas, 'P');

            this.loaded = loaded;
          },
        });
      },
    });
  }

  percentual(exec: number, plan: number, tipo: 'E' | 'P'): string {
    if (exec === undefined) exec = 0;
    if (plan === undefined) plan = 0;

    const base = (exec > plan) ? exec : plan;
    const ref = tipo === 'E' ? exec : plan;
    const porcentagem = !base ? 0 : (ref / base) * 100;
    return `${porcentagem < 100 ? porcentagem : 100}%`;
  }
}
